import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { batchPublish } from '../../../../actions/studio';
import { Props } from './SelectedLayout';
import { getIsUnpublishedDataset, getStudioParams } from '../../../../selectors/studio';
import { AppState } from '../../../../types/store';

export type StateProps = Pick<Props, 'isUnpublishedDataset' | 'contentType'>;
export type DispatchProps = Pick<Props, 'onSubmit'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  isUnpublishedDataset: getIsUnpublishedDataset(state),
  contentType: getStudioParams(state).contentType,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onSubmit: batchPublish,
};

export default connect(mapStateToProps, mapDispatchToProps);
